module.exports = __webpack_public_path__ + "static/footer_tablet-a002871a7ce18015689779ae1783a577.png";